<script lang="ts" setup>
import Button3 from '@/components/Button/Button3.vue'
import TextWithIcon from '@/components/TextWithIcon.vue'
import { useLocationStore } from '@/stores'
const props = defineProps({
  current: {
    type: Number,
    default: 0
  }
})
const route = useRoute()
const router = useRouter()
const topData: Ref<number> = ref(0)
const leftData: Ref<number> = ref(0)
const widthData: Ref<number> = ref(0)
const heightData: Ref<number> = ref(0)
const isShow: Ref<boolean> = ref(false)
const emit = defineEmits(['update:close'])

const openPop = (item: any) => {
  topData.value = item.y
  leftData.value = item.x
  widthData.value = item.width
  heightData.value = item.height
  setTimeout(() => {
    if (process.browser) {
      window.scrollTo(0, window.scrollY + item.top - 88)
    }
    isShow.value = true
  }, 100)
}

const closePop = () => {
  isShow.value = false
  emit('update:close', true)
}

defineExpose({ openPop })

// get data
const locationStore = useLocationStore()
const locations = computed(() => locationStore.locations)
const location = computed(() => locationStore.location)
const lineAt = computed(() => location.value?.social_media?.find((o) => o.name === 'line_at'))
const queryLocation = route.params.locationId
const locationIndex = locations.value.findIndex(
  (o) => o.id.toString() === queryLocation || o.seo.meta_slug === queryLocation
)
// 上下頁
const handleNextItem = () => {
  const routeQuery = route.query
  let queryString = ''
  if (locationIndex !== -1 && locations.value.length - 1 > locationIndex) {
    if (props.current === 11) {
      routeQuery.page = (parseInt(route.query.page as string) + 1).toString()
    }
    queryString = objectToSearch(routeQuery)
    const targetLocation = locations.value[locationIndex + 1]
    router.push(`/locations/${targetLocation.seo.meta_slug || targetLocation.id}?${queryString}`)
  }
}
const handlePrevItem = () => {
  const routeQuery = route.query
  let queryString = ''
  if (locationIndex > 0) {
    if (props.current === 0) {
      routeQuery.page = (parseInt(route.query.page as string) - 1).toString()
    }
    const queryString = objectToSearch(routeQuery)
    const targetLocation = locations.value[locationIndex - 1]
    router.push(`/locations/${targetLocation.seo.meta_slug || targetLocation.id}?${queryString}`)
  }
}
</script>

<template>
  <div class="pop" :class="{ isShow: isShow }" :style="{
    top: topData + 'px',
    left: leftData + 'px',
    width: widthData + 'px',
    height: heightData + 'px'
  }">
    <div class="pop__inner">
      <figure class="pop__banner">
        <Nimg :src="location?.image?.link" :alt="location?.image?.alt" :title="location?.image?.title" />
      </figure>
      <div class="pop__top">
        <div class="pop__title">{{ location?.subject }}</div>
        <div class="pop__opentime" v-html="location?.shop_hours"></div>
      </div>
      <div class="pop__bottom">
        <div class="pop__section">
          <div class="pop__section__title">聯絡我們</div>
          <div class="pop__contact">
            歡迎營業時間內，使用電話或 Line 與專櫃人員聯絡，若非營業時間留言，將於翌日回覆
          </div>
          <div class="pop__tel" v-if="location?.phone">{{ location?.phone }}</div>
          <div class="pop__icon">
            <nuxt-link :to="`tel:${location?.phone}`" v-if="location?.phone">
              <TextWithIcon class="pop__icon__item" :border="false" color="color-brand-3" icon="icon-phone"
                title="撥打電話" />
            </nuxt-link>
            <nuxt-link :to="lineAt?.url" target="_blank" v-if="lineAt?.url">
              <TextWithIcon class="pop__icon__item" radius border color="color-brand-3" icon="icon-line"
                title="Line 線上聯絡" />
            </nuxt-link>
          </div>
        </div>
        <div class="pop__section">
          <div class="pop__section__title">地址</div>
          <div class="pop__intro">
            {{ location?.zipcode ? `(${location?.zipcode})` : '' }}
            {{
              `${location?.region}
            ${location?.city}${location?.town}${location?.address}`
            }}
          </div>
          <div class="pop__icon">
            <nuxt-link
              :to="`https://www.google.com.tw/maps/place/${location?.region}${location?.city}${location?.town}${location?.address}`"
              target="_blank">
              <TextWithIcon class="pop__icon__item" radius border color="color-brand-3" icon="icon-map"
                title="Google map 導航" />
            </nuxt-link>
          </div>
        </div>
        <div class="pop__section">
          <div class="pop__section__title">據點描述</div>
          <div class="pop__intro" v-html="location?.description"></div>
        </div>
      </div>
      <div class="pop__feature">
        <Button3 class="pop__feature__button pop__feature__button--left" icon="icon-arrow-right2"
          @click="handlePrevItem" />
        <Button3 class="pop__feature__button--close" icon="icon-close" @click="closePop" />
        <Button3 class="pop__feature__button" icon="icon-arrow-right2" @click="handleNextItem" />
      </div>
    </div>
  </div>
  <div class="popMask" @click="closePop" :class="{ isShow: isShow }"></div>
</template>

<style lang="scss" scoped>
.pop {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 160;
  width: 100%;
  max-width: toRem(760);
  max-height: calc(100% - toRem(50));
  padding: toRem(24);
  font-size: toRem(16);
  background-color: $color-gray-1;
  transform: translate(0, 0) scale(0);
  transform-origin: left top;
  overflow-y: auto;
  opacity: 0;
  pointer-events: none;

  &.isShow {
    left: 50% !important;
    top: toRem(25) !important;
    width: 100% !important;
    height: auto !important;
    transform: translate(-50%, 0) scale(1);
    background-color: #fff;
    opacity: 1;
    pointer-events: auto;
    transition: all 0.5s ease-in-out;

    .pop {
      &__inner {
        opacity: 1;
        transition-delay: 0.5s;
      }
    }
  }

  &__inner {
    opacity: 0;
    transition: all 0.5s ease-in-out;
  }

  &__banner {
    margin-bottom: toRem(13);

    img {
      display: block;
      width: 100%;
    }
  }

  &__top {
    text-align: center;
    margin-bottom: toRem(60);
  }

  &__title {
    font-size: toRem(28);
    font-weight: 500;
    margin-bottom: toRem(13);

    @include max-media(480) {
      font-size: toRem(22);
    }
  }

  &__section {
    margin-bottom: toRem(20);

    &__title {
      font-size: toRem(22);
      font-weight: 500;
      margin-bottom: toRem(10);
    }
  }

  &__contact {
    color: $color-gray-1;
    margin-bottom: toRem(8);
  }

  &__intro {
    margin-bottom: toRem(8);
  }

  &__tel {
    margin-bottom: toRem(10);
  }

  &__icon {
    display: flex;

    &__item {
      margin-right: toRem(20);
    }
  }

  &__feature {
    display: flex;
    justify-content: space-between;

    &__button {
      &--left {
        :deep(svg) {
          transform: scaleX(-1);
        }
      }

      &--close {
        :deep(svg) {
          color: $color-gray-1;
        }
      }

      :deep(svg) {
        width: toRem(40);
        height: toRem(40);
      }
    }
  }
}

.popMask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(#000, 0.1);
  opacity: 0;
  pointer-events: none;
  z-index: 150;
  transition: all 0.5s ease-in-out;

  &.isShow {
    opacity: 1;
    pointer-events: auto;
  }
}
</style>
